"use strict";

if (document.querySelector('#product_size')) {
  var startID = document.querySelector('#product_size').value;
  var startValueList = ag_size[startID];
  document.getElementById('value-h').innerText = startValueList['h'];
  document.getElementById('value-l').innerText = startValueList['l'];
  document.getElementById('value-b').innerText = startValueList['b'];

  if (startValueList['img']) {
    document.getElementById('value-img').src = startValueList['img'];
  }

  document.querySelector('#product_size').addEventListener('change', function (e) {
    var ID = e.target.value;
    var valueList = ag_size[ID];
    document.getElementById('value-h').innerText = valueList['h'];
    document.getElementById('value-l').innerText = valueList['l'];
    document.getElementById('value-b').innerText = valueList['b'];

    if (valueList['img']) {
      document.getElementById('value-img').src = valueList['img'];
    }
  });
}